import React from 'react';
export const Hero = () => {
  return <div className="bg-gradient-to-b from-blue-900 to-blue-800 py-12 md:py-20 relative overflow-hidden" data-id="element-48">
      {/* American flag-inspired background elements */}
      <div className="absolute top-0 right-0 w-full h-32 bg-red-700 opacity-10" data-id="element-49"></div>
      <div className="absolute top-32 right-0 w-full h-32 bg-white opacity-10" data-id="element-50"></div>
      <div className="absolute top-64 right-0 w-full h-32 bg-red-700 opacity-10" data-id="element-51"></div>
      {/* Stars element */}
      <div className="absolute top-4 left-4 md:top-8 md:left-8" data-id="element-52">
        <div className="flex space-x-2" data-id="element-53">
          {[...Array(5)].map((_, i) => <svg key={i} className="w-6 h-6 text-white opacity-30" fill="currentColor" viewBox="0 0 24 24" data-id="element-54">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-55" />
            </svg>)}
        </div>
      </div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-56">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-57">
          <div className="md:w-1/2" data-id="element-58">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4" data-id="element-59">
              Remembering Charlie Kirk: The Official Legacy Edition
            </h1>
            <h2 className="text-xl md:text-2xl text-red-300 font-medium mb-6" data-id="element-60">
              His life and legacy preserved forever
            </h2>
            <p className="text-lg md:text-xl font-semibold text-gray-100 mb-6" data-id="element-61">
              A patriotic voice for America's future
            </p>
            <div className="mt-8 flex justify-center md:justify-start" data-id="element-62">
              <a href="#offer" className="inline-block bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300 border-2 border-white shadow-lg" data-id="element-63">
                Get My Copy Now – Only $19.97
              </a>
            </div>
          </div>
          <div className="md:w-1/2 relative" data-id="element-64">
            <div className="absolute inset-0 rounded-md bg-red-600 shadow-lg transform -rotate-12" data-id="element-65"></div>
            {/* Book Cover with Badge */}
            <div className="relative" data-id="element-66">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inq4dLe15a2qVGibMXnZAc/Charlie_kirk_book_cover.png" alt="Remembering Charlie Kirk Book Cover" className="w-full max-w-md mx-auto shadow-2xl rounded-md relative z-10" width="400" height="600" fetchpriority="high" data-id="element-67" />
              {/* "Now Available Online" Badge - Smaller size */}
              <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 w-16 h-16 md:w-20 md:h-20 z-20" data-id="element-68">
                <div className="relative w-full h-full" data-id="element-69">
                  <div className="absolute inset-0 rounded-full bg-red-600 shadow-lg transform -rotate-12 scale-90 sm:scale-100" data-id="element-70"></div>
                  <div className="absolute inset-1 rounded-full bg-blue-700 flex items-center justify-center" data-id="element-71">
                    <div className="text-center" data-id="element-72">
                      <p className="text-white text-[8px] md:text-[10px] font-bold" data-id="element-73">
                        NOW
                      </p>
                      <p className="text-white text-[8px] md:text-[10px] font-bold" data-id="element-74">
                        AVAILABLE
                      </p>
                      <p className="text-white text-[8px] md:text-[10px] font-bold" data-id="element-75">
                        ONLINE
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};